<script>
  import {
    VTimeline
  } from 'vuetify/lib'
  export default {
    name: 'wh-timeline',
    extends: VTimeline
  };
</script>